var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokMobileChevronWest = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 18,
  viewBox: "0 0 10 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m2.682 9 6.993 7.08c.433.439.433 1.151 0 1.59-.434.44-1.138.44-1.572 0L.325 9.795a1.135 1.135 0 0 1 0-1.59L8.103.33a1.1 1.1 0 0 1 1.572 0c.433.439.433 1.151 0 1.59z"
})));
export default SvgTiktokMobileChevronWest;